import InventoryModal from "../../../inventory/components/inventoryModal"
import getPrivilege from "../../../../utils/privileges/privileges"
import { Button } from "../../../../components/common"
import { useRef } from "react"

const UnitID = ({ data, privileges }) => {
  const inventoryModalRef = useRef()
  return (
    <div>
      {getPrivilege("can_view_unit_detail_page", privileges) ? (
        <Button
          className={"p-0"}
          type="link"
          text={data}
          onClick={() => {
            inventoryModalRef.current.showFor(data)
          }}
        />
      ) : (
        <div>{data}</div>
      )}
      <InventoryModal ref={inventoryModalRef} />
    </div>
  )
}
export default UnitID
